import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, IconButton, Typography } from "@mui/material";
import { type CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import React from "react";
import { ErrorIcon } from "./icons/ErrorIcon";

const variantIconsWithError = {
  error: ErrorIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  info: InfoIcon,
};

export const AppSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const {
    id,
    message,
    variant,
    persist: _persist,
    anchorOrigin: _anchorOrigin,
    autoHideDuration: _autoHideDuration,
    hideIconVariant: _hideIconVariant,
    iconVariant: _iconVariant,
    ...other
  } = props;
  const { closeSnackbar } = useSnackbar();
  const Icon =
    variant && variant in variantIconsWithError
      ? variantIconsWithError[variant as keyof typeof variantIconsWithError]
      : null;

  return (
    <SnackbarContent ref={ref} {...other}>
      <Box
        className={`notistack-MuiContent notistack-MuiContent-${variant}`}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {Icon && <Icon sx={{ fontSize: 20 }} />}
          <Typography variant="body1" color="text.primary">
            {message}
          </Typography>
        </Box>

        <IconButton size="small" aria-label="close" onClick={() => closeSnackbar(id)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </SnackbarContent>
  );
});
